import { render, staticRenderFns } from "./EditAmountDialog.vue?vue&type=template&id=2576b2d9&scoped=true"
import script from "./EditAmountDialog.vue?vue&type=script&lang=js"
export * from "./EditAmountDialog.vue?vue&type=script&lang=js"
import style0 from "./EditAmountDialog.vue?vue&type=style&index=0&id=2576b2d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2576b2d9",
  null
  
)

export default component.exports